import { Grid } from "@dealer-center/core-components";
import {
  ConfigCheckBox,
  ConfigClassification,
  ConfigInput,
  ConfigNumber,
  ConfigStatus,
  booleanInputsListFlat as bool,
  classificationTypeListFlat as classification,
  numberInputsListFlat as number,
  statusListFlat as status,
  textInputsListFlat as text
} from "./inputs";
import { StyledLegend } from "./Styles";
import { GridOfInputs } from "./GridOfInputs";
import { GridContainer } from "./GridContainer";

export const InputsList = () => {
  return (
    <>
      <StyledLegend>Display In Listing</StyledLegend>
      <GridContainer>
        <Grid>
          <ConfigCheckBox item={bool.showTotalCount} />
          <ConfigCheckBox item={bool.compare} />
          <ConfigCheckBox item={bool.epricer} />
          <ConfigCheckBox item={bool.featured} />
        </Grid>
        <Grid>
          <ConfigCheckBox item={bool.imaging} />
          <ConfigCheckBox item={bool.camera} />
          <ConfigCheckBox item={bool.toolTip} />
          <ConfigCheckBox item={bool.videoOnly} />
        </Grid>
        <Grid>
          <ConfigCheckBox item={bool.priority} />
          <ConfigCheckBox item={bool.makeOffer} />
          <ConfigCheckBox item={bool.smartBrowsing} />
          <ConfigCheckBox item={bool.paging} />
        </Grid>
        <Grid>
          <ConfigCheckBox item={bool.showCertifiedLogo} />
          <ConfigCheckBox item={bool.certified} />
          <ConfigCheckBox item={bool.carFaxOneOwnerOnly} />
          <ConfigCheckBox item={bool.excludeCertified} />
        </Grid>
        <Grid>
          <ConfigInput item={text.certifiedLogo} />
        </Grid>
      </GridContainer>
      <StyledLegend>Status</StyledLegend>
      <GridContainer>
        <Grid>
          <ConfigStatus item={status.statusList} />
        </Grid>
      </GridContainer>
      <StyledLegend>Classification</StyledLegend>
      <GridContainer>
        <Grid>
          <ConfigClassification item={classification.classificationTypes} />
        </Grid>
      </GridContainer>
      <StyledLegend>Sort</StyledLegend>
      <GridContainer>
        <Grid size={{ lg: 4, md: 6, sm: 12 }}>
          <ConfigInput item={text.defaultSortBy} />
        </Grid>
      </GridContainer>
      <StyledLegend>Filters</StyledLegend>
      <GridContainer>
        <GridOfInputs>
          <ConfigInput item={text.listingAccountId} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigInput item={text.listingAccountIds} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigInput item={text.excludedAccountIds} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigInput item={text.selectedAccountId} />
        </GridOfInputs>
        <Grid size={{ xs: 12 }}>
          <ConfigCheckBox item={bool.exclusiveAccountId} />
        </Grid>
        <GridOfInputs>
          <ConfigInput item={text.stickyMakes} />
          <ConfigInput item={text.selectedMakes} />
          <ConfigInput item={text.excludedMakes} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigInput item={text.stickyModels} />
          <ConfigInput item={text.selectedModels} />
          <ConfigInput item={text.excludedModels} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigInput item={text.stickyModelCodes} />
          <ConfigInput item={text.selectedModelCodes} />
          <ConfigInput item={text.excludedModelCodes} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigInput item={text.stickyTrims} />
          <ConfigInput item={text.selectedTrims} />
          <ConfigInput item={text.excludedTrims} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigInput item={text.stickyBodyStyles} />
          <ConfigInput item={text.selectedBodyStyles} />
          <ConfigInput item={text.excludedBodyStyles} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigInput item={text.stickyOptionCodes} />
          <ConfigInput item={text.selectedOptionCodes} />
          <ConfigInput item={text.excludedOptionCodes} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigInput item={text.stickyFuelTypes} />
          <ConfigInput item={text.selectedFuelTypes} />
          <ConfigInput item={text.excludedFuelTypes} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigInput item={text.stockNumberStartsWith} />
          <ConfigInput item={text.stockNumberEndsWith} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigNumber item={number.yearFloor} />
          <ConfigNumber item={number.yearCap} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigNumber item={number.minLotDays} />
          <ConfigNumber item={number.sharedMinLotDays} />
          <ConfigNumber item={number.maxLotDays} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigNumber item={number.baseCityMPG} />
          <ConfigNumber item={number.baseHighwayMPG} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigNumber item={number.mileageFloor} />
          <ConfigNumber item={number.mileageCap} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigNumber item={number.priceFloor} />
          <ConfigNumber item={number.priceCap} />
          <ConfigNumber item={number.priceEndsWith} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigInput item={text.defaultView} />
          <ConfigNumber item={number.visiblePageCount} />
          <ConfigNumber item={number.pageSize} />
          <ConfigNumber item={number.charLimit} />
        </GridOfInputs>
        <GridOfInputs>
          <ConfigInput item={text.listingTarget} />
          <ConfigInput item={text.imagesDirectory} />
          <ConfigInput item={text.compareTarget} />
        </GridOfInputs>
      </GridContainer>
    </>
  );
};
